export const LEADS_LIST_SCROLL_Y_KEY = 'hyrox:leads-list-scroll-y';
export const LEADS_LIST_SCROLL_RESTORE_KEY = 'hyrox:leads-list-scroll-restore';

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

type SaveLeadsListScrollOptions = {
  storage?: StorageLike | null;
  getScrollY?: () => number;
};

type ConsumeLeadsListScrollRestoreOptions = {
  storage?: StorageLike | null;
};

const getSessionStorage = (): StorageLike | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const saveLeadsListScroll = ({
  storage = getSessionStorage(),
  getScrollY = () => window.scrollY,
}: SaveLeadsListScrollOptions = {}): void => {
  if (!storage) {
    return;
  }

  try {
    storage.setItem(LEADS_LIST_SCROLL_Y_KEY, String(getScrollY()));
    storage.setItem(LEADS_LIST_SCROLL_RESTORE_KEY, '1');
  } catch {
    // storage may be full or restricted; navigation still proceeds
  }
};

export const consumeLeadsListScrollRestore = ({
  storage = getSessionStorage(),
}: ConsumeLeadsListScrollRestoreOptions = {}): number | null => {
  if (!storage) {
    return null;
  }

  try {
    const shouldRestore = storage.getItem(LEADS_LIST_SCROLL_RESTORE_KEY);
    if (shouldRestore !== '1') {
      return null;
    }

    const rawY = storage.getItem(LEADS_LIST_SCROLL_Y_KEY);
    storage.removeItem(LEADS_LIST_SCROLL_RESTORE_KEY);
    storage.removeItem(LEADS_LIST_SCROLL_Y_KEY);

    if (rawY == null) {
      return null;
    }

    const scrollY = Number(rawY);
    return Number.isFinite(scrollY) ? scrollY : null;
  } catch {
    return null;
  }
};
